import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucHaTangKyThuat } from 'src/app/shared/DanhMucHaTangKyThuat.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucHaTangKyThuatService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "DanhMucHaTangKyThuat";
    }
}

